import React from "react"
import WishlistPage from "../../components/WishlistPage/WishlistPage"
import Utils from "../../utils/node.utils"
import { StaticQuery, graphql } from "gatsby"

const WishlistIndexPage = ({ location }) => {
  Utils.NavigateToBrowserLanguage("es", "/wishlist", location.state)
  return (
    <StaticQuery
      query={pageQuery}
      render={data => {
        const commonContentMap = Utils.ContentListToMap(
          data.commonContent.item.content
        )
        const contentMap = Utils.ContentListToMap(
          data.wishlistContent.item.content
        )
        return (
          <WishlistPage
            title={contentMap.seo_title.value}
            description={contentMap.seo_description.value}
            breadCrumbs={["menu_home", "menu_wishlist"]}
            location={location}
            originPage="wishlist"
            language="es"
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            keywords={Utils.GetKeywordsFromTags(data.wishlistContent.item.tags)}
          />
        )
      }}
    />
  )
}

export default WishlistIndexPage

const pageQuery = graphql`
  {
    wishlistContent: wishlistContentEses {
      item {
        key
        tags {
          content {
            key
            value
          }
        }
        content {
          key
          value
        }
      }
    }

    commonContent: commonContentEses {
      item {
        key
        content {
          key
          value
        }
      }
    }
  }
`
